module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "style"
  }, [_c('img', {
    attrs: {
      "src": _vm.img
    }
  }), _vm._v(" "), (_vm.selected) ? _c('div', {
    staticClass: "select-item"
  }, [_c('a-icon', {
    attrs: {
      "type": "check"
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-06401fdc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/setting/StyleItem.vue
// module id = pAX8
// module chunks = 273